import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="materials-link"
// Hides all materials-link elements when any one is clicked
export default class extends Controller {
  connect() {
    // Use event delegation to handle clicks on any .materials-link element
    this.boundHandleClick = this.handleClick.bind(this)
    this.element.addEventListener("click", this.boundHandleClick)
  }

  disconnect() {
    if (this.boundHandleClick) {
      this.element.removeEventListener("click", this.boundHandleClick)
    }
  }

  handleClick(event) {
    // Check if the clicked element or its parent has the materials-link class
    const clickedLink = event.target.closest(".materials-link")
    if (clickedLink) {
      // Hide all elements with the materials-link class
      const allLinks = this.element.querySelectorAll(".materials-link")
      allLinks.forEach(link => {
        link.style.visibility = "hidden"
      })
    }
  }
}
